var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrlSmallGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.95 2.5C0.95 1.645 1.645 0.95 2.5 0.95H4.5V0H2.5C1.12 0 0 1.12 0 2.5C0 3.88 1.12 5 2.5 5H4.5V4.05H2.5C1.645 4.05 0.95 3.355 0.95 2.5ZM3 3H7V2H3V3ZM7.5 0H5.5V0.95H7.5C8.355 0.95 9.05 1.645 9.05 2.5C9.05 3.355 8.355 4.05 7.5 4.05H5.5V5H7.5C8.88 5 10 3.88 10 2.5C10 1.12 8.88 0 7.5 0Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlSmallGreen);
export default __webpack_public_path__ + "static/media/url-small-green.475d3aeacdcbc9e09f5acdee1229594d.svg";
export { ForwardRef as ReactComponent };